import React, { useState } from 'react';
import { Container, Form, Button, Alert, Card } from 'react-bootstrap';
import CustomNavbar from '../components/Navbar';
import Footer from '../components/Footer';
import Seo from '../components/Seo';
import PrEditor from '../components/PrEditor';
import { easternToUtcIso, submitPrPost } from '../api/prPost';

const STORAGE_KEY = 'prPostPassword';

function PrPostPage() {
  const expected = process.env.REACT_APP_PR_POST_PASSWORD || '';
  const [password, setPassword] = useState(
    () => sessionStorage.getItem(STORAGE_KEY) || ''
  );
  const unlocked = expected !== '' && password === expected;

  const [passwordInput, setPasswordInput] = useState('');
  const [gateError, setGateError] = useState('');

  const [dateTime, setDateTime] = useState('');
  const [title, setTitle] = useState('');
  const [contentHtml, setContentHtml] = useState('');
  const [contentEmpty, setContentEmpty] = useState(true);
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle'); // idle | submitting | success | error
  const [errorMessage, setErrorMessage] = useState('');
  const [editorKey, setEditorKey] = useState(0); // bump to reset the editor

  const handleUnlock = (e) => {
    e.preventDefault();
    if (expected !== '' && passwordInput === expected) {
      setPassword(passwordInput);
      sessionStorage.setItem(STORAGE_KEY, passwordInput);
      setGateError('');
    } else {
      setGateError('Incorrect password.');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!dateTime || !title.trim() || contentEmpty || !email.trim()) {
      setStatus('error');
      setErrorMessage('Please fill in all fields.');
      return;
    }
    setStatus('submitting');
    setErrorMessage('');
    try {
      await submitPrPost({
        postDateTimeUtc: easternToUtcIso(dateTime),
        title: title.trim(),
        contentHtml,
        submitterEmail: email.trim(),
        password,
      });
      setStatus('success');
      setDateTime('');
      setTitle('');
      setEmail('');
      setContentHtml('');
      setContentEmpty(true);
      setEditorKey((k) => k + 1);
    } catch (err) {
      setStatus('error');
      setErrorMessage(
        'Submission failed. Your entries have been kept — please try again.'
      );
    }
  };

  return (
    <div>
      <Seo title="PR Post" noindex path="/admin/post" />
      <CustomNavbar />
      <Container className="py-5" style={{ maxWidth: '760px', minHeight: '60vh' }}>
        <h3 className="mb-4">Submit a Press Release</h3>
        {!unlocked ? (
          <Card className="p-4">
            <Form onSubmit={handleUnlock}>
              <Form.Group className="mb-3" controlId="prPostPassword">
                <Form.Label>Password</Form.Label>
                <Form.Control
                  type="password"
                  value={passwordInput}
                  onChange={(e) => setPasswordInput(e.target.value)}
                  autoFocus
                />
              </Form.Group>
              {gateError && <Alert variant="danger">{gateError}</Alert>}
              <Button type="submit" variant="dark">
                Unlock
              </Button>
            </Form>
          </Card>
        ) : (
          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3" controlId="prPostDateTime">
              <Form.Label>Post Date &amp; Time (Eastern Time)</Form.Label>
              <Form.Control
                type="datetime-local"
                value={dateTime}
                onChange={(e) => setDateTime(e.target.value)}
                required
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="prPostTitle">
              <Form.Label>Post Title</Form.Label>
              <Form.Control
                type="text"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                required
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Post Content</Form.Label>
              <PrEditor
                key={editorKey}
                onChange={(html, isEmpty) => {
                  setContentHtml(html);
                  setContentEmpty(isEmpty);
                }}
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="prPostEmail">
              <Form.Label>Your Email</Form.Label>
              <Form.Control
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </Form.Group>
            {status === 'success' && (
              <Alert variant="success">PR submitted successfully.</Alert>
            )}
            {status === 'error' && <Alert variant="danger">{errorMessage}</Alert>}
            <Button type="submit" variant="dark" disabled={status === 'submitting'}>
              {status === 'submitting' ? 'Submitting…' : 'Submit PR'}
            </Button>
          </Form>
        )}
      </Container>
      <Footer />
    </div>
  );
}

export default PrPostPage;
